import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import auth from '@/modules/authorization/store';
import commonStore from '@/shared/store';
// import betsStore from '@/modules/bets/store';
import Statements from '@/modules/statements/store';
import WalletStore from '@/modules/wallet/store';
import fantasyCricketStore from '@/modules/cricket-fight/store';
import sportsStore from '@/modules/sports/store'

const mutations = {
  resetState(state) {
    state.auth.user = null;
    state.auth.token = null;
    state.auth = {
      user: null,
      chips: null,
      token: null,
      lock_settings: null,
      eventDetailHideSections: []
    };
  }
}
const actions = {
  resetAllState({ commit }) {
    commit('resetState')
  }
}

export default createStore({
  state: {},
  mutations,
  actions,
  modules: { auth, commonStore, Statements, WalletStore, fantasyCricketStore, sportsStore },
  plugins: [createPersistedState({
    key:'sd:site'
  })]
});
